import Skeleton from 'react-loading-skeleton'

const ProductSkeletonLoader = () => {

    return (

        <div style={{ padding: '20px', display: 'flex', flexDirection: 'row', height: '100vh', width: '100%' }}>
        {/* Image placeholder */}
        <div style={{ marginRight: '20px', flexBasis: '40%' }}>
          <Skeleton height="80%" width="100%" />
        </div>

        <div style={{ flex: 1 }}>
          {/* Product title */}
          <Skeleton height={60} width="80%" style={{ marginBottom: '10px' }} />

          {/* Price */}
          <Skeleton height={20} width="65%" style={{ marginBottom: '10px' }} />

          {/* Rating */}
          <Skeleton height={20} width="50%" style={{ marginBottom: '10px' }} />

          {/* Description */}
          <Skeleton height={60} width="90%" style={{ marginBottom: '10px' }} />
          <Skeleton height={60} width="85%" style={{ marginBottom: '10px' }} />
          <Skeleton height={60} width="80%" style={{ marginBottom: '10px' }} />

          {/* Additional details */}
          <Skeleton height={20} width="75%" style={{ marginBottom: '10px' }} />
          <Skeleton height={20} width="70%" style={{ marginBottom: '10px' }} />
          <Skeleton height={60} width="65%" style={{ marginBottom: '10px' }} />
        </div>
      </div>
    )


}

export default ProductSkeletonLoader